import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["container"];

    connect() {
        this.scrollToLi();
    }

    scrollToLi() {
        const liElement = this.element;
        const container = this.element.parentElement;
        const elementTop = liElement.offsetTop;
        const elementHeight = liElement.clientHeight;
        const containerHeight = container.clientHeight;
        container.scrollTop = elementTop - containerHeight / 2 + elementHeight / 2;
    }
}